





























import Vue from 'vue';
import {
  PersonalSettings,
  HSASettings,
} from '@/components/account-settings-components';
import { LoadingService } from '@/services';
import store from '@/store';
import { EventBus } from '@/event-bus';
import { MemberAccountResponseModel } from '@/@types/member';

export default Vue.extend({
  name: 'AccountSettingsOverview',
  beforeRouteEnter(to, from, next) {
    LoadingService.watchPromises(store.dispatch('getPersonalInformation'))
      .then(async () => {
        const RESPONSE = await store.dispatch('getProviders');
        const TOTAL_ITEMS = RESPONSE.headers[
          'x-total-count'
        ];
        store.dispatch('setTotalItems', TOTAL_ITEMS);
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  computed: {
    accounts(): MemberAccountResponseModel[] {
      return this.$store.getters.accounts;
    },
    activeHSAAccounts(): MemberAccountResponseModel[] {
      return this.$store.getters.activeHSAAccounts;
    },
    activeVEBAAccounts(): MemberAccountResponseModel[] {
      return this.$store.getters.activeVEBAAccounts;
    },
    activeFSAAccounts(): MemberAccountResponseModel[] {
      return this.$store.getters.activeFSAAccounts;
    },
    activeHRAAccounts(): MemberAccountResponseModel[] {
      return this.$store.getters.activeHRAAccounts;
    },
  },
  components: {
    PersonalSettings,
    HSASettings,
  },
});
